import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslatorlangService {
 
  private jsonUrls: any = {
    en: 'assets/i18n/en.json',
    mr: 'assets/i18n/mr.json',
    publisheren: 'assets/i18n/publisher.json',
    publishermr: 'assets/i18n/publishermr.json'
  };

  constructor(private http: HttpClient) { }

  private sharedData = new BehaviorSubject<any[]>([]);
  translateAllList = this.sharedData.asObservable();

  private languageChange = new BehaviorSubject<any[]>([]);
  LanguageChangeData = this.languageChange.asObservable();

  updateData(data: any) {
    this.sharedData.next(data); // Update the shared data
  }

  updateLanguageData(data: any) {
    this.languageChange.next(data); // Update the shared data
  }

  getTranslation(lang: string): Observable<any> {
    const url = this.jsonUrls[lang];
    return this.http.get<any>(url).pipe(
      catchError((error) => {
        console.error('Error fetching translation:', error);
        return of({});
      })
    );
  }
}
